export default "__VITE_ASSET__Cu1mRq$2__"